import React, { useState } from 'react'
import { SettingsHeader } from '../../../UserSettingsPages/components/SettingsStyles'
import {
	FAQHeaderText, StyledAccordionItem, AccordionClose, AccordionContent, AccordingStatment, AccordionHeader
} from '../FAQHelpStyles'
import { Bold } from '../../../Global/GobalStyledComponents';

const FAQMembership = () => {
	const [whyMember, setWhyMember] = useState(false);
	const [changePassEmail, setChangePassEmail] = useState(false);
	const [emailMessage, setEmailMessage] = useState(false);
	const [customLineup, setCustomLineup] = useState(false);
	const [makeCustomeLineup, setMakeCustomLineup] = useState(false);

	return (
		<>
			<SettingsHeader>Membership</SettingsHeader>
			<StyledAccordionItem>
				<AccordionHeader onClick={() => setWhyMember(!whyMember)}>
					<FAQHeaderText>Why Should I Become a TitanTV Member?</FAQHeaderText>
					{whyMember ? <AccordionClose> - </AccordionClose> : <AccordionClose> + </AccordionClose>}
				</AccordionHeader>
				<AccordionContent isOpen={whyMember ? 'block' : 'none'}>
					<AccordingStatment>
						TitanTV members have access to some features that are not available to guest visitors. Membership is free and requires creating a user name and password.
					</AccordingStatment>
					<AccordingStatment>
						Members may customize their lineups by hiding unwanted lineups and adding others. Another benefit of becoming a member is their customized lineups and all preference choices are stored on TitanTV's servers for easy recall on any computer simply by logging in to the account.
					</AccordingStatment>
					<AccordingStatment>
						Finally, members may select up to 500 programs as favorites. Guest visitors are limited to a maximum of 200.
					</AccordingStatment>
				</AccordionContent>
			</StyledAccordionItem>

			<StyledAccordionItem>
				<AccordionHeader onClick={() => setChangePassEmail(!changePassEmail)}>
					<FAQHeaderText>How Do I Change My Account's Password or Email Address?</FAQHeaderText>
					{changePassEmail ? <AccordionClose> - </AccordionClose> : <AccordionClose> + </AccordionClose>}
				</AccordionHeader>
				<AccordionContent isOpen={changePassEmail ? 'block' : 'none'}>
					<AccordingStatment>
						TitanTV members may change the password or email address associated with their account within TitanTV.
					</AccordingStatment>
					<AccordingStatment>
						Click the Main Menu link in the top left corner of any page.  Under the My Account section, click the Update Account Information link to go to the My Account page where these updates may be made.
					</AccordingStatment>
					<AccordingStatment>
						To change the account's email address, replace the displayed address with the new email address.
					</AccordingStatment>
					<AccordingStatment>
						To change the account's password, first enter the current password where prompted.  Then enter the new password at its prompt and again in its confirmation field.
					</AccordingStatment>
					<AccordingStatment>
						To put the new email address and/or password into effect, click the Save Changes.  The account will then be associated with the new credentials.
					</AccordingStatment>
				</AccordionContent>
			</StyledAccordionItem>

			<StyledAccordionItem>
				<AccordionHeader onClick={() => setEmailMessage(!emailMessage)}>
					<FAQHeaderText>Why Do I Get a Message that My Email Address is in Use When Creating a TitanTV Membership?</FAQHeaderText>
					{emailMessage ? <AccordionClose> - </AccordionClose> : <AccordionClose> + </AccordionClose>}
				</AccordionHeader>
				<AccordionContent isOpen={emailMessage ? 'block' : 'none'}>
					<AccordingStatment>
						A TitanTV membership may be associated with only one email address.  If you receive this message, in means your email address is already associated with an existing TitanTV account and cannot be used when creating another.
					</AccordingStatment>
					<AccordingStatment>
						If you receive this message, use the Contact link to describe the situation and the TitanTV staff will send you the original account's credentials.
					</AccordingStatment>
				</AccordionContent>
			</StyledAccordionItem>

			<StyledAccordionItem>
				<AccordionHeader onClick={() => setCustomLineup(!customLineup)}>
					<FAQHeaderText>What is a Custom Lineup?</FAQHeaderText>
					{customLineup ? <AccordionClose> - </AccordionClose> : <AccordionClose> + </AccordionClose>}
				</AccordionHeader>
				<AccordionContent isOpen={customLineup ? 'block' : 'none'}>
					<AccordingStatment>
						A feature available only to TitanTV members is the ability to create a true custom lineup.  A custom lineup starts out empty and contains only the channels they choose to include.  This allows them to merge channels from multiple lineups into a single, custom lineup.
					</AccordingStatment>
					<AccordingStatment>
						Creating a custom lineup is also strongly recommended as an alternative to hiding a large number of channels in a predefined lineup.
					</AccordingStatment>
					<AccordingStatment>
						Though the site permits users to hide dozens, or even hundreds, of channels in a predefined lineup, the drawback of doing so is the possibility that the display status of all those channels in that lineup may be reset whenever TitanTV's data provider changes the lineup by adding new channels, removes any that have gone dark, or updates the roster to reflect changes in network affiliations.
					</AccordingStatment>
					<AccordingStatment>
						Custom lineups are exempt from the changes that TitanTV's data provider may perform to a predefined lineup.
					</AccordingStatment>
				</AccordionContent>
			</StyledAccordionItem>

			<StyledAccordionItem>
				<AccordionHeader onClick={() => setMakeCustomLineup(!makeCustomeLineup)}>
					<FAQHeaderText>How Do I Customize a Lineup to Display Only the Channels I Want to Appear?</FAQHeaderText>
					{customLineup ? <AccordionClose> - </AccordionClose> : <AccordionClose> + </AccordionClose>}
				</AccordionHeader>
				<AccordionContent isOpen={makeCustomeLineup ? 'block' : 'none'}>
					<AccordingStatment>
						The ability to customize lineups by hiding unwanted channels is a feature that is available to TitanTV members like yourself.
					</AccordingStatment>
					<AccordingStatment>
						Please read the following instructions completely. There is a significant difference between customizing a predefined lineup by hiding unwanted channels or adding others and creating a truly custom lineup that starts empty and contains only the channels you specifically wish to add.  Each method has its own advantages and disadvantages.
					</AccordingStatment>
					<AccordingStatment>
						<Bold>CUSTOMIZE A PREDEFINED LINEUP:</Bold> These instructions will step you through the process of hiding the channels you do not want to appear in your grid.  This type of customization is intended to work best when hiding only a small number of channels.
					</AccordingStatment>
					<AccordingStatment>
						To do so, click on the Gear Box icon in the center of the header bar above the grid.  The grid will redraw to display a number of tabs.  Click on the My Lineups tab.
					</AccordingStatment>
					<AccordingStatment>
						The page will redraw to display a list containing each lineup associated with your account.
					</AccordingStatment>
					<AccordingStatment>
						Locate the lineup in the list you wish to edit and click on its Edit Channels button.  The page will redraw to list each channel in that lineup.
					</AccordingStatment>
					<AccordingStatment>
						To hide a channel, click on its Hide button.  The background for that channel will change to orange and the button's label will change from Hide to Show to provide visual indicators of that channel's change of display status.
					</AccordingStatment>
					<AccordingStatment>
						Repeat the above step for each channel that you wish to hide.
					</AccordingStatment>
					<AccordingStatment>
						If you accidentally click the Hide button on a channel that you actually want to appear in your lineup, click on its Show button.  Its background color will return to grey and the button's label will change back to Hide to provide visual indicators of that channel's change of display status.
					</AccordingStatment>
					<AccordingStatment>
						Changes to the lineup are automatically saved as you make them.  Once you have hidden the desired channels, click the TitanTV Listings link in the top left corner of the page.
						The grid will appear with the selected channels hidden from view.
					</AccordingStatment>
					<AccordingStatment>
						Please note that the channels in a lineup that are provided by default cannot be permanently removed from the lineup.  These channels may only be hidden.
					</AccordingStatment>
					<AccordingStatment>
						The drawback to performing a large number of edits to a predefined lineup is our data may update that lineup at some point by adding new channels, removing those that have gone dark, or updating the roster to reflect changes in network affiliations. When they do, it is possible for the display status of all the channels in that lineup will be reset and all the channels will become visible again.
					</AccordingStatment>
					<AccordingStatment>
						<Bold>CREATE A CUSTOM LINEUP:</Bold>  If a lineup provided by default by TitanTV is going to be heavily edited in such a way by hiding a large number of channels, a better alternative is to create a true Custom lineup.  We will refer to this type of lineup as a Custom with a capital C to distinguish it from any provided lineup that has been customized.
					</AccordingStatment>
					<AccordingStatment>
						A Custom lineup starts out completely empty, has much less dependence on any provided lineups, and contains only those channels that you choose to appear in it.
					</AccordingStatment>
					<AccordingStatment>
						If desired, a Custom lineup can also contain channels from multiple sources.  This allows all of your favorite channels from multiple markets and/or sources to be displayed in a single Custom lineup.
					</AccordingStatment>
					<AccordingStatment>
						For example, if you live in an area where you are able to receive broadcast channels from two television markets, you may create a single Custom lineup that contains your favorite OTA channels from both markets.
					</AccordingStatment>
					<AccordingStatment>
						To create a Custom lineup, click the Gear icon on the header above the grid.  The grid will redraw to display a number of tabs.  Click on the My Lineups tab.
					</AccordingStatment>
					<AccordingStatment>
						The page will redraw to display a list containing each lineup associated with your account.  Click the Create Custom Lineup button.
					</AccordingStatment>
					<AccordingStatment>
						A box will open prompting you for a name for the new lineup. Enter a meaningful name and click the Save button.  The box will close, and the page will redraw to show the contents of the new Custom lineup.  It will be empty at this point.
					</AccordingStatment>
					<AccordingStatment>
						Next, click the blue Add Channels button at the top of the list. A popup opens prompting you to choose a source for the new channels.  Select the Choose Channels to Add from an Existing Lineup option.
					</AccordingStatment>
					<AccordingStatment>
						The popup redraws to list the lineups associated with your account. Select the lineup that you will use as the source for the Custom lineup.  The popup will redraw again to list all of the channels in that lineup.
					</AccordingStatment>
					<AccordingStatment>
						The list contains only the channels in that lineup that have not been hidden.  It is assumed that a user who creates a Custom lineup is not going to choose to subsequently include any channels that he or she had previously hidden.
					</AccordingStatment>
					<AccordingStatment>
						Click on each channel in the source lineup you want to add. Multiple selections are allowed in this window so scroll through the list and click on each desired channel.  The background of each selected channel turns green to further illustrate it has been selected.  If you choose a wrong channel, click it again to deselect it.
					</AccordingStatment>
					<AccordingStatment>
						When finished with selecting the channels to add, click the Add Channels button. The popup will close, and the selected channels will be added to the new Custom lineup in the background.
					</AccordingStatment>
					<AccordingStatment>
						Changes to a lineup are saved as they are made so there is no explicit Save function to put all your changes into effect.
					</AccordingStatment>
					<AccordingStatment>
						Next, click the blue Set As Default button at the top of the list. This instructs TitanTV to always go to this new lineup whenever you go to the grid.
					</AccordingStatment>
					<AccordingStatment>
						Finally, click the TitanTV icon at the extreme top left margin to return to the grid. If necessary, select the Custom lineup from the drop-down box to view it in the grid.  It will now display the selected channels in the new Custom lineup.
					</AccordingStatment>
					<AccordingStatment>
						The drawback to creating a Custom lineup in this way is that any changes the data provider makes to any stations in your lineup will not automatically be reflected in your Custom lineup.  You will have to manually edit the lineup to update its contents.
					</AccordingStatment>


				</AccordionContent>
			</StyledAccordionItem>
		</>
	)
}

export default FAQMembership